import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {environment} from '../../../../../environments/environment';
import {language} from '../../../../language/vn';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {CommandUtil} from '../../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {ToTrinhFile} from '../../../../models/totrinh/totrinhfile';
import {ToTrinh} from '../../../../models/totrinh/totrinh';
import {ToTrinhFileService} from '../../../../service/totrinh/service-totrinhfile';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {ToTrinhXuLy} from '../../../../models/totrinh/totrinhxuly';
import {ToTrinhComment} from '../../../../models/totrinh/totrinhcomment';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {ToTrinhCommentService} from '../../../../service/totrinh/service-totrinhcomment';
import {BsModalService} from 'ngx-bootstrap/modal';
import {TongHopYKienToTrinhComponent} from './tonghop.component';
import {FileToTrinhComponent} from './file.component';
import {DanhSachTHToTrinhComponent} from './danhsach.component';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
import {YKienXuLyToTrinhComponent} from './ykienxl.component';
import {ThoiHanToTrinhComponent} from './thoihan.component';
import {JoinToTrinhComponent} from './join.component';
import {ChuyenTrinhComment} from '../../../../models/totrinh/chuyentrinhcomment';
import {ChuyenTrinhCommentService} from '../../../../service/totrinh/service-chuyentrinhcomment';
import {ChuyenTrinh} from '../../../../models/totrinh/chuyentrinh';
import {PdfShowComponent} from '../../view/pdf.component';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {LogFileComponent} from '../../log/logfile.component';
import {LogView} from '../../../../models/log/logview';
import {LogViewService} from '../../../../service/log/service-logview';
@Component({
  selector: 'xulytotrinh-detail',
  templateUrl: './detailtotrinh.component.html',

})
export class XuLyDetailToTrinhComponent implements OnInit, AfterViewInit {
  @Input() toTrinhId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  public totalItems: number = 0;
  private moduleName: string = 'egov.info.totrinh.xuly';
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public language = language;
  public showAction = true;
  public toTrinhItem: ToTrinh = new ToTrinh();
  public toTrinhXuLyItem: ToTrinhXuLy = new ToTrinhXuLy();
  public toTrinhFiles: ToTrinhFile[] = [];
  public toTrinhXuLyList: ToTrinhXuLy[] = [];
  public toTrinhCommentList: ToTrinhComment[]=[];
  public fileLists: Object[]=[];
  public urlExportToTrinh: string = environment.exportToTrinh;
  public urlPrintToTrinh: string= environment.printToTrinh;
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public hoanThanhList: ToTrinhXuLy[] = [];
  public chuaXuLyList: ToTrinhXuLy[] = [];
  public dangXuLyList: ToTrinhXuLy[] = [];
  public chuyenTrinhItem: ChuyenTrinh = new ChuyenTrinh();
  public chuyenTrinhCommandList: ChuyenTrinhComment[] = [];
  public isOpen: boolean = false;
  public permissionGiaoXuLy: boolean = false;
  public permissionSuaThoiHan: boolean = false;
  public permissionXuLyLai: boolean = false;
  public permissionChuyenGiaoViec: boolean = false;
  public permissionYKienTongHop: boolean = false;
  public permissionDownload: boolean = false;
  public permissionXuLy: boolean = true;
  public permissionYKien: boolean = false;
  public permissionChuyenHoanThanh: boolean = false;
  public permissionDownloadFileComment: boolean = false;
  public logViewList: LogView[] = [];
  private dataComment: Object[] = [];
  constructor(
    public toTrinhService: ToTrinhService,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public toTrinhFileService: ToTrinhFileService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public bsModalService: BsModalService,
    public toTrinhCommentService: ToTrinhCommentService,
    public chuyenTrinhCommendService: ChuyenTrinhCommentService,
    public rolePermissionService: RolePermissionService,
    public logViewService: LogViewService

  ) {  }
  ngAfterViewInit() {
  }
  public thoiHan() {
    const modalEdit = this.bsModalService.show(ThoiHanToTrinhComponent);
    (<ThoiHanToTrinhComponent>modalEdit.content).edit(
      this.toTrinhId
    );
    (<ThoiHanToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.toTrinhId);
    });
  }

  public getXuLyById(sId: number, s: boolean): string
  {

    let xl: ToTrinhXuLy = this.toTrinhXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau : xl.thoiGianXemLanCuoi);

  }

  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.toTrinhXuLyService.changeStatus(this.toTrinhId, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              if(data!==-1)
              {
                this.toastr.success(language.change_hoanthanh_success, language.message);
                Sessioncommand.giaiQuyetSuVuStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_success, language.message);

              this.edit(this.toTrinhId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public join() {
    const modalEdit = this.bsModalService.show(JoinToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<JoinToTrinhComponent>modalEdit.content).edit(
      this.toTrinhId
    );
    (<JoinToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.toTrinhId);
    });

  }
  public edit(id: number)
  {
    this.toTrinhId = id;
    this.toTrinhService.getById(id).subscribe(x => {this.toTrinhItem = x;
      this.toTrinhXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(data => {
        this.toTrinhXuLyItem = data;
      });
      this.toTrinhFileService.findAllByToTrinhId(id).subscribe( x => this.toTrinhFiles = x);

      this.toTrinhXuLyService.findByMaYeuCau(id).subscribe( data => {this.toTrinhXuLyList = data;
        this.hoanThanhList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.hoanthanh);
        this.dangXuLyList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.dangxuly);
        this.chuaXuLyList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.chuaxuly);
        this.loadComment(this.toTrinhId);
      });
      this.chuyenTrinhCommendService.findAllByClassPK(id).subscribe( data => this.chuyenTrinhCommandList = data);
    });

  }
  ngOnInit(): void {

    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
          this.permissionSuaThoiHan = x.findIndex( y => y.action === environment.suathoihan ) !== -1;
          this.permissionXuLyLai = x.findIndex( y => y.action === environment.xulylai ) !== -1;
          this.permissionChuyenGiaoViec = x.findIndex( y => y.action === environment.chuyengiaoviec ) !== -1;
          this.permissionYKienTongHop = x.findIndex( y => y.action === environment.ykientonghop ) !== -1;
          this.permissionDownload = x.findIndex( y => y.action === environment.download ) !== -1;
          this.permissionChuyenHoanThanh = x.findIndex( y => y.action === environment.chuyenhoanthanh ) !== -1;
          this.permissionGiaoXuLy = x.findIndex( y => y.action === environment.giaoxuly ) !== -1;
          this.permissionYKien = x.findIndex( y => y.action === environment.ykien ) !== -1;
          this.permissionDownloadFileComment = x.findIndex( y => y.action === environment.taifilecomment ) !== -1;
    });
    this.edit(this.toTrinhId);
    //document.getElementById("refNote").setAttribute("value", "1" );
  }
  public showXuLy(toTrinhList: ToTrinhXuLy[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHToTrinhComponent>modalEdit.content).edit(
      toTrinhList
    );
    (<DanhSachTHToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public showLichSu()
  {
    const modalEdit = this.bsModalService.show(LogFileComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<LogFileComponent>modalEdit.content).show(
      "com.egov.api.repository.model.totrinh.ToTrinhFile", this.toTrinhId
    );

  }
  public loadComment(id: number)
  {
    this.logViewList  = [];
    this.toTrinhCommentService.getCountByKeyword(id).subscribe( data => this.totalItems = data);
    this.logViewService.findAllByMaVBAndStaffId(id, Sessioncommand.staffId, environment.TOTRINH).subscribe(x => {
      this.logViewList = x;
      this.toTrinhCommentService.findAllByStaffIdPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(data => {
        this.toTrinhCommentList = data;
      });
    });

  }
  private checkNew(commentId: number): boolean
  {
    return this.logViewList.findIndex(x => x.refId === commentId) !== -1;
  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(TongHopYKienToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienToTrinhComponent>modalEdit.content).edit(
      this.toTrinhId
    );
    (<TongHopYKienToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public yKienXuLy() {
    const modalEdit = this.bsModalService.show(YKienXuLyToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKienXuLyToTrinhComponent>modalEdit.content).edit(
      this.toTrinhId
    );
    (<YKienXuLyToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.toTrinhId);
    });

  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileToTrinhComponent>modalEdit.content).edit(
      id
    );
    (<FileToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
        this.loadComment(this.toTrinhId);
    });

  }
  showFile(id: number) {
    this.toTrinhFileService.findAllByToTrinhId(id).subscribe( x => {
      if(x.length>0)
      {
        const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
        (<PdfShowComponent>modalEdit.content).show(
          this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)

        );
        (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
          if (result === true) {

          }
        });
      }
    });


  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.toTrinhId);
  }
  public xuLyLai()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_xulylai_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.toTrinhXuLyService.xuLyLai(this.toTrinhId, environment.chuaxuly, this.toTrinhItem.maNguoiChuTri).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.message_xulylai_success, language.message);
              Sessioncommand.giaiQuyetSuVuStatus = 0;
              Sessioncommand.notification = true;
              this.edit(this.toTrinhId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }



}

